import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";

export default function ServiceCard({ icon: Icon, title, description, points, href, accentGold = false, testId }) {
  return (
    <Link
      to={href}
      data-testid={testId}
      className="group lift-card block bg-white border border-[#cbd5e1] rounded-2xl p-8 h-full"
    >
      <div className={`inline-flex items-center justify-center w-14 h-14 rounded-xl mb-6 ${accentGold ? "bg-[#d4af37]/10 text-[#d4af37]" : "bg-[#1e6dd8]/10 text-[#1e6dd8]"}`}>
        <Icon className="w-7 h-7" strokeWidth={1.6} />
      </div>
      <h3 className="font-serif-hsa text-2xl font-semibold text-[#0a2540] mb-3 leading-tight">{title}</h3>
      <p className="text-slate-600 text-[15px] leading-relaxed mb-5">{description}</p>
      <ul className="space-y-2 mb-6">
        {points.slice(0, 4).map((p) => (
          <li key={p} className="flex items-start gap-2 text-sm text-slate-700">
            <Check className="w-4 h-4 text-[#1e6dd8] mt-0.5 flex-shrink-0" />
            <span>{p}</span>
          </li>
        ))}
      </ul>
      <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#0a2540] group-hover:text-[#1e6dd8] transition-colors">
        Learn more <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
      </span>
    </Link>
  );
}
